<template>
  <div>
    {{hours}}
    <el-tag size="mini">h</el-tag>
    {{minutes}}
    <el-tag size="mini">m</el-tag>
    {{seconds}}
    <el-tag size="mini">s</el-tag>
  </div>
</template>

<script>
export default {
  name: 'BaseTravelTime',
  props: {
    delay: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  },
  methods: {
    setData() {
    },
  },
  beforeMount() {
    this.setData();
  },
};
</script>

<style scoped>

</style>
